function resolveSupabaseUrl(): string {
  return (
    import.meta.env.VITE_SUPABASE_URL ||
    import.meta.env.EXPO_PUBLIC_SUPABASE_URL ||
    ''
  );
}

function resolveSupabaseAnonKey(): string {
  return (
    import.meta.env.VITE_SUPABASE_ANON_KEY ||
    import.meta.env.EXPO_PUBLIC_SUPABASE_ANON_KEY ||
    ''
  );
}

// Environment configuration with fallbacks (coherent with Expo `EXPO_PUBLIC_*` in root `.env`)
export const env = {
  supabase: {
    url: resolveSupabaseUrl(),
    anonKey: resolveSupabaseAnonKey(),
  },
  isDev: import.meta.env.DEV,
  isProd: import.meta.env.PROD,
};

// Validate required environment variables
export function validateEnv() {
  const errors: string[] = [];
  
  if (!env.supabase.url) {
    errors.push('VITE_SUPABASE_URL or EXPO_PUBLIC_SUPABASE_URL is required');
  }
  
  if (!env.supabase.anonKey) {
    errors.push('VITE_SUPABASE_ANON_KEY or EXPO_PUBLIC_SUPABASE_ANON_KEY is required');
  }
  
  if (errors.length > 0) {
    console.error('[Environment] Missing required variables:', errors);
    if (env.isProd) {
      throw new Error(`Missing required environment variables: ${errors.join(', ')}`);
    }
  }
  
  return errors.length === 0;
}

// Initialize environment validation
validateEnv();